/**
 * Message of a failed request of the orders view, for a list load or an action (link, unlink, delete, edit date,
 * approve…). The API's own message is kept only when the server answered with one (409, 422…). A network failure
 * has status 0 and, with the fetch backend, `error.error.message` is the raw browser text ("Failed to fetch"), so
 * it always falls back to the translated text. A 5xx carries the framework's English text ("Internal server error"),
 * so it falls back too (ENF-2472). The `{ success: false, error: { code, message } }` body of the enrollment platform
 * endpoints (ENF-2494) carries an English message: it falls back too, or reads its code with `apiErrorCode`.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const { status, error: body } = (error ?? {}) as { status?: number; error?: { message?: unknown; success?: unknown } | null };
  if (status === 0 || (status !== undefined && status >= 500)) return fallback;
  if (body?.success === false) return fallback;
  const message = body?.message;
  return typeof message === 'string' && message.trim() ? message : fallback;
}

/** Code of a `{ success: false, error: { code } }` answer (ENF-2494), or null. */
export function apiErrorCode(error: unknown): string | null {
  const body = (error as { error?: { success?: unknown; error?: { code?: unknown } } } | null)?.error;
  const code = body?.success === false ? body.error?.code : null;
  return typeof code === 'string' && code ? code : null;
}
